var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.25C10.2721 8.2548 9.57545 8.54608 9.06077 9.06077C8.54608 9.57545 8.2548 10.2721 8.25 11C8.25 12.5052 9.49483 13.75 11 13.75C12.5043 13.75 13.75 12.5052 13.75 11C13.75 9.49575 12.5043 8.25 11 8.25Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 4.58301C4.00343 4.58301 1.9006 10.6486 1.88135 10.71L1.78418 10.9997L1.88043 11.2893C1.9006 11.3508 4.00343 17.4163 11.0003 17.4163C17.9973 17.4163 20.1001 11.3508 20.1193 11.2893L20.2165 10.9997L20.1203 10.71C20.1001 10.6486 17.9973 4.58301 11.0003 4.58301ZM11.0003 15.583C6.09526 15.583 4.19501 12.0575 3.73485 10.9997C4.19685 9.93817 6.09801 6.41634 11.0003 6.41634C15.9054 6.41634 17.8057 9.94184 18.2658 10.9997C17.8038 12.0612 15.9027 15.583 11.0003 15.583Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b5360b8964defcf6418847b6aa8f18ad.svg";
export { ForwardRef as ReactComponent };